var moment = require('moment');

export const groupSameSeriesSameDayMarketingDates = (events) => {
  const groups = new Map();
  const result = [];

  events.forEach((event) => {
    const seriesId = event.event_series_id;
    // Desktop events carry a localized `start` (Date); mobile payloads carry
    // `start_date_iso`. Use whichever is present to derive the calendar day.
    const dayKey = event.start_date_iso
      || (event.start ? moment(event.start).format("YYYY-MM-DD") : null);

    if (!seriesId || !dayKey || !(event.is_marketing_date ?? false)) {
      result.push(event);
      return;
    }

    const key = `${seriesId}::${dayKey}`;
    const marketingDate = {
      id: event.id,
      classification: event.classification,
      start: event.start,
      date: event.date
    };

    if (!groups.has(key)) {
      const grouped = { ...event, grouped_series_count: 1, grouped_marketing_dates: [marketingDate] };
      groups.set(key, grouped);
      result.push(grouped);
    } else {
      const grouped = groups.get(key);
      grouped.grouped_series_count += 1;
      grouped.grouped_marketing_dates.push(marketingDate);
    }
  });

  groups.forEach((grouped) => {
    const seen = new Set();
    const spansMultipleEvents =
      new Set(grouped.grouped_marketing_dates.map((marketingDate) => marketingDate.id)).size > 1;

    grouped.grouped_marketing_dates = grouped.grouped_marketing_dates
      .sort((a, b) => new Date(a.start || a.date) - new Date(b.start || b.date))
      .filter((marketingDate) => {
        const at = new Date(marketingDate.start || marketingDate.date).getTime();
        const key = `${marketingDate.classification}::${at}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

    if (grouped.grouped_series_count > 1) {
      grouped.is_series_group = true;
      grouped.spans_multiple_events = spansMultipleEvents;

      if (grouped.series_url) {
        grouped.url = grouped.series_url;
      }
    }
  });

  return result;
};
